import { createContext, useContext, useEffect } from 'react';

// Tema kalıcı olarak light moda sabitlendi (kullanıcı tercihi)
const ThemeContext = createContext({ theme: 'light', setTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    root.classList.add('light');
    // Eski dark mode tercihini sil
    try { localStorage.removeItem('theme'); } catch {}
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: 'light', setTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
